import React from "react";

const Header = ({ title }) => (
  <div style={{marginLeft: '2px'}}>
    <h2>{title}</h2>
  </div>
);

export default Header;
